// Types
import type {
  ErrorAccordionBuilderHandlersType,
  ErrorAccordionMethodsHandlersType,
} from './types/error-accordion.handlers.type';

const copyStackTraceErrorButtonClickHandler = ({
  error,
}: ErrorAccordionBuilderHandlersType): void => {
  window.navigator.clipboard.writeText(error);
};

const ErrorAccordionHandlers = (
  props: ErrorAccordionBuilderHandlersType
): ErrorAccordionMethodsHandlersType => ({
  handleCopyStackTraceErrorButtonClick: () => copyStackTraceErrorButtonClickHandler(props),
});

export { ErrorAccordionHandlers };
